// @flow
import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Row,
  Col,
  Popover,
  PopoverHeader,
  PopoverBody,
  ButtonGroup
} from "reactstrap";
import "./../../node_modules/react-select/dist/react-select.css";
import Select, { Creatable } from "react-select";
import { bindActionCreators } from "redux";
import * as actions from "../actions";
import { compose, checkForm, setIn } from "../common/utils";
import * as API from "../common/api";
import styled from "../common/styled";
import { s3Delete, s3Move } from "../common/aws_lib";

const { Text, Image, View } = styled.plain;

const checks = [
  {
    related: ["photoName"],
    check: s => true,
    errMsg: () => "photoName Required"
  },
  {
    related: ["photoAlt"],
    check: s => true,
    errMsg: () => "photoAlt Required"
  },
  {
    related: ["categories"],
    check: s => true,
    errMsg: () => "categoriesRequired"
  },
  {
    related: ["subcategories"],
    check: s => true,
    errMsg: () => "subcategories Required"
  },
  {
    related: ["tags"],
    check: s => true,
    errMsg: () => "tags Required"
  }
];

const checkFormData = checkForm(checks);

class PhotoMultiForm extends React.Component {
  state = {
    errMsg: null,
    isSubmitting: false,
    formData: {
      photoAlt: "",
      categories: [],
      subcategories: [],
      tags: []
    },
    popoverOpen: false
  };

  componentDidMount() {
    this.props.loadCategories();
  }

  componentWillReceiveProps(nextProps) { }

  toggleDelete = () => {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  };

  onChangeField = (key, val) => {
    const state = setIn(["formData", key], val, this.state);
    this.setState(state);
    if (key === "categories") {
      this.setState(setIn(["formData", "subcategories"], [], state));
    }
  };

  validateForm = fields => {
    const data = this.state.formData;
    const errMsgs = checkFormData(data, fields);
    const newErrMsgs =
      fields && fields.length > 0
        ? { ...this.state.errMsgs, ...errMsgs }
        : errMsgs;
    const hasError =
      Object.keys(newErrMsgs).filter(key => newErrMsgs[key]).length > 0;

    if (!fields && hasError) {
      const firstError = Object.keys(errMsgs)
        .map(key => errMsgs[key])
        .filter(x => !!x)[0];
      toast.error(firstError);
    }

    this.setState({ errMsgs: newErrMsgs });
    return !hasError;
  };

  onSubmit = next => {
    if (!this.validateForm()) return;

    const data = this.state.formData;
    const photoIds = this.props.selectedPhotos.map(x => x.photoId);
    return actions.wrapLoading(
      this.props,
      API.UpdatePhotoMulti(
        photoIds,
        data.categories,
        data.subcategories,
        data.tags,
        data.photoAlt
      )
        .then(
          result => {
            toast.success("Successfully Updated");
            return this.props.onDone();
          },
          e => {
            const msg = e.message;
            toast.error(msg);
          }
        )
        .catch(e => {
          console.log(e);
        })
    );
  };

  onDelete = () => {
    const photos = this.props.selectedPhotos.map(x => ({ photoKey: x.photoKey, fileExt: x.fileExt || '.jpg' }));
    const prefix = "public/";
    const promises = [];
    photos.forEach(photo => {
      const files = [
        `${prefix}${photo.photoKey}-full${photo.fileExt}`,
        `${prefix}${photo.photoKey}-web${photo.fileExt}`,
        `${prefix}${photo.photoKey}-thumb${photo.fileExt}`
      ];
      files.forEach(item => {
        const promise = s3Delete(item);
        promises.push(promise);
      });
    });

    return actions.wrapLoading(
      this.props,
      Promise.all(promises)
        .then(values => this.deletePhotos())
        .catch(e => {
          console.log(e);
        })
    );
  };

  deletePhotos = () => {
    const photoIds = this.props.selectedPhotos.map(x => x.photoId);

    API.DeletePhotoMulti(photoIds)
      .then(
        result => {
          toast.success("Successfully Deleted");
          return this.props.onDone();
        },
        e => {
          const msg = e.message;
          toast.error(msg);
        }
      )
      .catch(e => {
        console.log(e);
      });
  };

  render() {
    const categories = (this.props.categories || []).map(item => ({
      label: item.categoryName,
      value: item.categoryName
    }));
    const foundCategories = (this.props.categories || []).filter(item =>
      this.state.formData.categories.includes(item.categoryName)
    );
    let subcategories = [];
    foundCategories.forEach(cat => {
      const subs = (cat.subcategories || []).map(item => ({
        label: item,
        value: item
      }));
      subcategories = subcategories.concat(subs);
    });
    const tags = this.state.formData.tags.map(item => ({
      label: item,
      value: item
    }));
    console.log(subcategories);
    return (
      <Modal
        isOpen={this.props.visible}
        className="photoModal"
        onClosed={this.props.onClose}
        size="lg"
      >
        <ModalHeader>Edit Muliple Photos</ModalHeader>
        <ModalBody>
          <Form className="photo-form">
            <FormGroup>
              {this.props.selectedPhotos.map(item => (
                <PhotoHolder key={item.photoId}>
                  <PhotoImage src={item.thumbnail} />
                  <div style={{ padding: "4px" }}>{item.photoName}</div>
                </PhotoHolder>
              ))}
            </FormGroup>
            <div className="form-field">
              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>Categories</Label>
                    <Select
                      multi
                      name="categories"
                      required
                      value={this.state.formData.categories}
                      onChange={e =>
                        this.onChangeField(
                          "categories",
                          e.map(item => item.value)
                        )
                      }
                      options={categories}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>Subcategories</Label>
                    <Select
                      multi
                      name="subcategories"
                      required
                      value={this.state.formData.subcategories}
                      onChange={e =>
                        this.onChangeField(
                          "subcategories",
                          e.map(item => item.value)
                        )
                      }
                      options={subcategories}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>Tags</Label>
                    <Creatable
                      multi
                      name="tags"
                      required
                      value={this.state.formData.tags}
                      onChange={e =>
                        this.onChangeField(
                          "tags",
                          e.map(item => item.value)
                        )
                      }
                      options={tags}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>Alt Text</Label>
                    <Input
                      type="text"
                      name="photoAlt"
                      required
                      value={this.state.formData.photoAlt}
                      onChange={e =>
                        this.onChangeField("photoAlt", e.target.value)
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>

              <div>Leave a field blank to keep its original value</div>
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={this.props.onClose}>
            Cancel
          </Button>
          <Button
            id="Popover1"
            color="danger"
            outline
            onClick={this.toggleDelete}
          >
            Delete All
          </Button>

          <Popover
            placement="top"
            isOpen={this.state.popoverOpen}
            target="Popover1"
            toggle={this.toggleDelete}
          >
            <PopoverHeader>Are you sure you want to delete all?</PopoverHeader>
            <PopoverBody>
              <Button color="danger" outline onClick={this.onDelete}>
                Confirm
              </Button>
            </PopoverBody>
          </Popover>
          <Button color="primary" outline onClick={() => this.onSubmit(false)}>
            Update All
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

PhotoMultiForm.propTypes = {
  selectedPhotos: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired
};

export default compose(
  connect(
    state => ({
      categories: state.categories.list
    }),
    dispatch => bindActionCreators({ ...actions }, dispatch)
  ),
  withRouter
)(PhotoMultiForm);

const PhotoHolder = styled.View`
  width: 120px;
  height: auto;
  display: inline-block;
  margin-left: 4px;
  margin-bottom: 4px;
  vertical-align: top;
`;

const PhotoImage = styled.Image`
  width: 100%;
  height: auto;
`;
